import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../_metronic/_partials/controls'
import Table, { dateFormatter, buttonsStyle } from '../../../components/tables/table'
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'
import { getUsers, deleteUser, changeStatusUser } from '../../../../api/user'
import { Button, Tooltip, Switch, FormControlLabel } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import { alertError, alertSuccess } from '../../../../utils/logger'
import { useHistory } from 'react-router-dom'
import ToggleOffIcon from '@material-ui/icons/ToggleOff';
import ToggleOnIcon from '@material-ui/icons/ToggleOn';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import FiltersCard from '../../../components/filters/Filter';
import { getCredentials } from '../../../../api/auth'
import { authActions } from '../../Auth/_redux/authActions'
import { getLanguages } from '../../../../api/language'

function getData(admins) {
  let data = []
  for (let i = 0; i < admins.length; ++i) {
    if (admins[i].isAdmin) {
      const elem = {}
      elem.name = admins[i].fullName
      elem.surname = admins[i].surname
      elem.email = admins[i].email
      elem.createdAt = admins[i].createdAt
      elem.id = admins[i]._id
      elem.isTherapist = admins[i].isTherapist;
      elem.active = admins[i].active;
      data = data.concat(elem)
    }
  }
  return data
}

const initialFilters = {
	active: false
}

export default function AdminsPage() {
	const [data, setData] = useState([])
	const [adminId, setAdminId] = useState(null)
	const [openConfirmDialog, setOpenConfirmDialog] = useState(null)
	const [refresh, setRefresh] = useState(false)
	const [users, setUsers] = useState([])
	const [filteredData, setFilteredData] = useState([]);
	const [collapsed, setCollapsed] = useState(true)
	const [filterOptions, setFilterOptions] = useState(initialFilters)
	const history = useHistory()
	const user = useSelector((store) => store.authentication?.user, shallowEqual)
	const dispatch = useDispatch()

	useEffect(() => {
		fetchUser();
	}, [])

	useEffect(() => {
		getUsers().then((res) => {
			if (res.status === 200) {
				setData(res.data)
				setFilteredData(res.data)
				setUsers(res.data)
				setRefresh(false)
			}
			}).catch(error => {
				alertError({ error: error, customMessage: 'No se ha podido recoger a los administradores.' })
			})
	}, [refresh])
	
	async function fetchUser() { //POR SI SE HA ACTUALIZADO EL USUARIO ACTUAL
		try {
			const response = await getCredentials()
			if (response)
				dispatch(authActions.loginActionSuccess(response?.data))
				const languages = await getLanguages();
				if (languages?.data) {
					dispatch(authActions.getLanguagesSuccess(languages?.data));
				}
		} catch (error) {
			dispatch(authActions.logoutAction())
		}
	}

	const columns = [
		{ dataField: 'name', text: 'Nombre completo', formatter: nameFormatter, sort: true },
		{ dataField: 'email', text: 'Email', sort: true },
		{ dataField: 'isTherapist', text: 'Terapeuta', formatter: isTherapistFormat, sort: true },
		{ dataField: 'id', text: '', formatter: buttonFormatter, align: 'right' }
	]

	function nameFormatter(cell, row) {
        return `${cell}${row?.surname ? ` ${row?.surname}` : ""}`
    }

	function buttonFormatter(cell) {
		const elem = data.find(item => item._id === cell)
		return (
			<>
				<Tooltip title='Editar'>
					<Button
						style={buttonsStyle}
						size='small'
						onClick={() => history.push('/edit-admin/' + cell)}>
						<EditIcon />
					</Button>
				</Tooltip>
				{user?.isAdmin && <>
					<Tooltip title={elem?.active ? "Deshabilitar" : "Habilitar"}>
						<Button
							style={buttonsStyle} size="small"
							onClick={() => {
								setAdminId(elem)
								setOpenConfirmDialog(1)
							}}>
							{elem?.active ? <ToggleOffIcon/> : <ToggleOnIcon style={{ color: 'red' }} />}
						</Button>
					</Tooltip>
					<Tooltip title='Borrar'>
						<Button
							style={buttonsStyle}
							size='small'
							onClick={() => {
								setAdminId(elem);
								setOpenConfirmDialog(2);
							}}>
							<DeleteIcon />
						</Button>
					</Tooltip>
				</>}
			</>
		);
	}

	function isTherapistFormat(cell) {
		return (cell ? "Si" : "No");
	}

	const handleSearch = async () => {
		if (!data.length) return
		setFilteredData(data.filter(item => {
		  	let filter = true
			if (filterOptions.active) filter = filter && item.active
			if (filter) return item
			return false
		}))
	}

	const handleClearFilters = () => {
		setFilterOptions(initialFilters)
		setRefresh(true)
	}

	const renderFiltersContent = () => {
		return <>
			<br/>
			<FormControlLabel
				control={<Switch checked={filterOptions.active} onChange={() => setFilterOptions({ ...filterOptions, active: !filterOptions.active })} name="checkActive" />}
				label={filterOptions.active ? "Activos" : "Todos activos/inactivos"}
			/>
		</>
	}

  return (
    <>
      <Card>
        <CardHeader title='Administradores'>
          <CardHeaderToolbar>
              <button
                type="button"
                className="btn btn-primary text-white"
                onClick={() => history.push('/edit-admin')}
              >
                Añadir
              </button>
            </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
			<FiltersCard 
				filtersContent={renderFiltersContent}
				collapsed={collapsed} 
				setCollapsed={setCollapsed}
				handleClearFilters={handleClearFilters}
				handleSearch={handleSearch}
			/>

			<Table data={getData(filteredData, users)} columns={columns} />

          	<ConfirmDialog
				title={`Seguro que quieres ${adminId?.active ? 'deshabilitar' : 'habilitar'} el administrador?`}
				open={openConfirmDialog === 1}
				setOpen={setOpenConfirmDialog}
				onConfirm={() => {
					changeStatusUser(adminId._id, !adminId?.active)
						.then((res) => {
							if (res.status === 200) {
								alertSuccess({ title: `${adminId?.active ? 'Deshabilitado!' : 'Habilitado!'}`, customMessage: `Administrador ${adminId?.active ? 'deshabilitado' : 'habilitado'} correctamente.` })
								setRefresh(true);
							}
						})
						.catch((error) => {
							alertError({ error: error, customMessage: `No se ha podido ${adminId?.active ? 'deshabilitar' : 'habilitar'} el administrador.` })
						});
				}}
			/>
			<ConfirmDialog
				title={'Seguro que quieres eliminar el administrador?'}
				open={openConfirmDialog === 2}
				setOpen={setOpenConfirmDialog}
				onConfirm={() => {
					deleteUser(adminId._id)
						.then((res) => {
							if (res.status === 204 || res.status === 200) {
								alertSuccess({
									title: 'Eliminado!',
									customMessage: 'Administrador eliminado correctamente!.',
								});
								setRefresh(true);
							}
						})
						.catch((error) => {
							alertError({
								error: error,
								customMessage: 'No se ha podido eliminar el administrador.',
							});
						});
				}}
			/>
        </CardBody>
      </Card>
    </>
  );
}
